<!-- The phone's "More" tab: the rest of this group's pages, other groups, and your settings. -->
<script lang="ts">
  import { app } from "../lib/store.svelte.ts";
  import { groupPath, link } from "../lib/router.svelte.ts";
  import { ICONS } from "../lib/icons.ts";
  import { nav } from "../lib/nav.svelte.ts";

  const gid = $derived(nav.openGid!);
  const groupName = $derived(nav.groups.find((g) => g.id === gid)?.name ?? app.current.name);
  const ALL = [
    { page: "trips", label: "Receipts and catalog", icon: ICONS.receipts },
    { page: "insights", label: "Overview", icon: ICONS.overview },
    { page: "history", label: "History", icon: ICONS.history },
    { page: "settings", label: "Group settings", icon: ICONS.settings },
  ] as const;
  // Only the pages whoever is looking can open.
  const pages = $derived(ALL.filter((p) => nav.canSee(p.page)));
</script>

<div class="page">
  <div class="page-head"><div><h1>{groupName}</h1></div></div>

  <nav class="menu" aria-label="Group pages">
    {#each pages as p}
      <a href={groupPath(gid, p.page)} use:link>
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d={p.icon} /></svg>{p.label}
      </a>
    {/each}
  </nav>

  {#if nav.groups.length > 1}
    <h2 class="label">Other groups</h2>
    <nav class="menu" aria-label="Other groups">
      {#each nav.groups.filter((g) => g.id !== gid) as g (g.id)}
        <a href={groupPath(g.id)} use:link><span class="dot" aria-hidden="true"></span>{g.name}</a>
      {/each}
    </nav>
  {/if}

  <h2 class="label">Everything</h2>
  <nav class="menu" aria-label="Everything">
    <a href="/" use:link><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d={ICONS.overview} /></svg>Overview</a>
    <a href="/you" use:link><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d={ICONS.you} /></svg>Your settings</a>
  </nav>
</div>

<style>
  .menu {
    display: grid;
    border-radius: var(--r-md);
    overflow: hidden;
    box-shadow: inset 0 0 0 1px var(--rule);
    background: var(--surface);
  }

  .menu a {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    color: var(--ink);
    text-decoration: none;
    font-weight: 550;
  }

  .menu a + a {
    border-top: 1px solid var(--rule);
  }

  .menu a:active {
    background: var(--wash);
  }

  .label {
    margin: 24px 0 8px;
    font-size: var(--t-sm);
    color: var(--muted);
    font-weight: 600;
  }

  .dot {
    width: 10px;
    height: 10px;
    margin: 0 5px;
    border-radius: 50%;
    background: var(--muted);
  }

  svg path {
    fill: none;
    stroke: currentColor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
</style>
